module.exports = __webpack_public_path__ + "img/logo.d62ad976.png";